/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 * Virtual record for map with known enum keys
 */

export const getByIdRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.noauth.TrackPublicChirpService',
  rpcName: 'getById',
  auth: 'external',
  fingerprint: '8wmW0arbCOVyptfncTalJe-ymnNyhEw2',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};